import React, { Component } from "react";
import { withRouter } from "react-router";

class AuthFooterComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }


    render() {
        return (
            <div className="page-ath-footer">
                <ul className="footer-links">
                    <li><a href="regular-page.html">Privacy Policy</a></li>
                    <li><a href="regular-page.html">Terms</a></li>
                    <li>© 2021 Unifiedorbit.</li>
                </ul>
            </div>
        );
    }
}

export default withRouter(AuthFooterComponent);
